import fastify from 'fastify'
import websocket from '@fastify/websocket'
import chokidar from 'chokidar'
import type { Logger } from './types'
import cors from '@fastify/cors'
import { createState } from './state'
import { attachWatcherSocketEvents } from './socket'

/** Create a watch server to send config changes to the client */
export async function createServer(
  configPath: string,
  onMessage: Logger,
  options: {
    proxy: string
  },
) {
  const server = fastify()
  await server.register(websocket)
  await server.register(cors, {
    origin: ['*'],
  })

  const state = createState()

  const watcher = chokidar.watch(configPath, {})
  watcher.add(configPath)

  server.addHook('onClose', () => {
    watcher.close()
  })

  server.get('/socket', { websocket: true }, async (socket) => {
    attachWatcherSocketEvents({
      socket,
      options,
      configPath,
      state,
      onMessage,
      watcher,
    })
  })

  /** Serve the document content atomically to avoid a large initial fetch from the client */
  server.get('/content/:uid', (req, reply) => {
    const uid = (req.params as { uid: string }).uid

    const content = state.references[uid] ?? state.pageContent[uid]

    if (!content) {
      return reply.status(404).send({ error: 'Content not found' })
    }

    return reply.type('application/json').send(content)
  })

  return server
}
